export default __webpack_public_path__ + "static/media/img5-2.4258baaa.jpg";